import { useQuery } from "@tanstack/react-query";
import { formatDatasource, getDatasource } from "~/lib/storyblok/getDatasource";

export type DatasourceType = "pdp-text" | "text-snippets";

export const useDatasource = (datasource: DatasourceType) => {
	const locale = undefined; // TODO: get locale from router
	const { data, isLoading } = useQuery({
		queryKey: ["datasource", datasource, locale],

		queryFn: () => getDatasource(datasource, locale),
	});

	if (isLoading) return (label: string) => label;

	const formatted = formatDatasource(data);

	const getField = (field: string) => {
		const item = formatted.find((item: any) => item.name === field);
		if (!item) return field;

		return item.value;
	};

	return getField;
};
